import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { IMAGE_CONSTANTS } from '../../constants/ImageConstans';
import { COLORS_CONSTANTS } from '../../constants/Colors';
import { TEXT_LABELS } from '../../constants/TextLabelConstants';
import { FONTS } from '../../constants/Fonts';
import { ROUTE_ENUM } from '../../routes/RoutesConstant';
import ProfileTileWithLogout from './ProfileTileWithLogout';
import Breadcrumb from './Breadcrumb';

const NAV_LINK_STYLE = {
  fontFamily: FONTS.INTER_MEDIUM,
  fontWeight: 500,
  fontSize: 24,
  lineHeight: '32px',
  letterSpacing: 0.8,
  textDecoration: 'none',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  background: 'none',
  border: 'none',
  padding: 0,
};

const TopHeader = ({
  isBreadcrumbVisible = false,
  breadCrumbShowBack = true,
  breadCrumbOnBack,
  breadCrumbItems = [],
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isGameZoneActive =
    location.pathname === ROUTE_ENUM.SELECT_GAME.routePath ||
    location.pathname.startsWith('/Rap') ||
    location.pathname.startsWith('/Games');

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        paddingTop: 10,
        paddingBottom: 10,
      }}
    >
      <div
        style={{
          width: '100%',
          minHeight: 110,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: 20,
          borderRadius: 500,
          background: COLORS_CONSTANTS.HEADER_PILL_BACKGROUND,
          border: `2px solid ${COLORS_CONSTANTS.HEADER_PILL_BORDER}`,
          boxShadow: COLORS_CONSTANTS.HEADER_PILL_SHADOW,
          backdropFilter: 'blur(25px)',
          WebkitBackdropFilter: 'blur(25px)',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            flexShrink: 0,
            paddingLeft: 12,
          }}
        >
          <button
            type="button"
            onClick={() => navigate(ROUTE_ENUM.SELECT_GAME.routePath)}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
            aria-label="Rapchik home"
          >
            <img
              src={IMAGE_CONSTANTS.V2_HEADER_LOGO}
              alt="Rapchik"
              style={{
                height: 70,
                width: 70,
                display: 'block',
                objectFit: 'contain',
                borderRadius: '50%',
              }}
            />
          </button>
          {isBreadcrumbVisible && (
            <Breadcrumb
              showBack={breadCrumbShowBack}
              onBack={breadCrumbOnBack || (() => navigate(ROUTE_ENUM.SELECT_GAME.routePath))}
              items={breadCrumbItems}
            />
          )}
        </div>

        <nav
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 38,
            flex: 1,
          }}
        >
          <button
            type="button"
            onClick={() => navigate(ROUTE_ENUM.SELECT_GAME.routePath)}
            style={{
              ...NAV_LINK_STYLE,
              color: isGameZoneActive
                ? COLORS_CONSTANTS.HEADER_NAV_ACTIVE
                : COLORS_CONSTANTS.HEADER_NAV_INACTIVE,
            }}
          >
            {TEXT_LABELS.HEADER_NAV_GAME_ZONE}
          </button>
          <a
            href={TEXT_LABELS.HEADER_ABOUT_US_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              ...NAV_LINK_STYLE,
              color: COLORS_CONSTANTS.HEADER_NAV_INACTIVE,
            }}
          >
            {TEXT_LABELS.HEADER_NAV_ABOUT_US}
          </a>
          <a
            href={TEXT_LABELS.HEADER_CONTACT_US_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              ...NAV_LINK_STYLE,
              color: COLORS_CONSTANTS.HEADER_NAV_INACTIVE,
            }}
          >
            {TEXT_LABELS.HEADER_NAV_CONTACT_US}
          </a>
        </nav>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flexShrink: 0,
            minWidth: 118,
          }}
        >
          <ProfileTileWithLogout variant="header" />
        </div>
      </div>
    </div>
  );
};

TopHeader.propTypes = {
  isBreadcrumbVisible: PropTypes.bool,
  breadCrumbShowBack: PropTypes.bool,
  breadCrumbOnBack: PropTypes.func,
  breadCrumbItems: PropTypes.array,
};

export default TopHeader;
